import Header from "./components/Header";
import StaysList from "./components/StaysList";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Header></Header>
      <StaysList></StaysList>
      <Footer></Footer>
    </div>
  );
}

export default App;
